import applicationManagementReducer from "./applicationManagementReducer";
import registrationManagementReducer from "./registrationManagementReducer";
import inspectionListReducer from "./inspectionListReducer";

const applicationManagementReducers = {
    applicationManagement: applicationManagementReducer,
    registrationManagement: registrationManagementReducer,
    inspectionList: inspectionListReducer
}

export default applicationManagementReducers;